import { Controller } from "react-hook-form";
import Form from "../../../components/Form";
import FormHolder from "../../../components/Form/FormHolder";
import { useSiteState } from "../../../utils/useSiteState";
import { TextInput } from "djinn-components";
import FormFieldErrors from "../../../components/Form/FormFieldErrors";
import SiteImageHolder from "../../../components/Forms/ProjectEdit/SiteImageHolder";

const SiteSettingsIndex = () => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { title, description, favicon } = site;

    return {
      title,
      description,
      favicon,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
  };

  return (
    <>
      <title>Site Metadata</title>
      <FormHolder>
        <Form
          getDefaults={getDefaults}
          onCompleted={onSubmit}
          buttonTitle="Update Metadata"
          endpoint={`sites/${site.id}`}
          method="put"
          render={({ errors, control }) => (
            <>
              <h4 className="font-medium text-xl text-white">Site Metadata</h4>
              <p className="text-sm font-light text-gray-200">
                This will be used for search engines and browsers accessing your
                site so make it relevant to your apps data.
              </p>
              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Meta Title
                </label>
                <Controller
                  name="title"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: true,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <TextInput
                      value={value}
                      onChange={onChange}
                      invalid={!!errors.title}
                      placeholder="Site Title"
                    />
                  )}
                />

                <FormFieldErrors
                  errors={errors}
                  field="title"
                  requiredMessage="Site title is required"
                />
              </div>

              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Meta Description
                </label>
                <Controller
                  name="description"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: true,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <TextInput
                      value={value}
                      onChange={onChange}
                      invalid={!!errors.description}
                      placeholder="Site description"
                    />
                  )}
                />

                <FormFieldErrors
                  errors={errors}
                  field="description"
                  requiredMessage="Site description is required"
                />
              </div>

              <div className="mb-4 mt-6">
                <Controller
                  name="favicon"
                  control={control}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <SiteImageHolder
                      setImage={onChange}
                      id="favicon"
                      type="app_logo"
                      image={value}
                      sClass="w-3/4 h-24"
                      imageBg="bg-gray-200"
                      label="Favicon"
                      description="The image that will be shown in browsers."
                      imagePlaceholder="/logo-placeholder.png"
                    >
                      <ul>
                        <li>Logo must be visible on a light background</li>
                        <li>Recommended image 200px x 200px</li>
                        <li>Maximum file size of 1mb.</li>
                      </ul>
                    </SiteImageHolder>
                  )}
                />
                <FormFieldErrors
                  errors={errors}
                  field="logo"
                  requiredMessage="A logo is required"
                />
              </div>
            </>
          )}
        />
      </FormHolder>
    </>
  );
};

export default SiteSettingsIndex;
